var exports = {
  "x": "x93eb46d8--daa38d--button",
};

module.exports = exports;
